import { render } from "./AlgoliaSearchComponent.vue?vue&type=template&id=acb786b2"
import script from "./AlgoliaSearchComponent.vue?vue&type=script&lang=js"
export * from "./AlgoliaSearchComponent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/src/services/admin/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__